export function formatBRL(value) {
  const v = Number(value || 0);
  return v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export function formatDate(value) {
  if (!value) return "-";
  try {
    const d = new Date(value);
    return d.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  } catch (_) {
    return String(value);
  }
}

export function formatDateTime(value) {
  if (!value) return "-";
  try {
    const d = new Date(value);
    return d.toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch (_) {
    return String(value);
  }
}

export const STATUS_LABEL = {
  trial: "Trial",
  active: "Ativa",
  suspended: "Suspensa",
  expired: "Vencida",
  cancelled: "Cancelada",
  open: "Aberto",
  analyzing: "Em análise",
  answered: "Respondido",
  resolved: "Resolvido",
  closed: "Fechado",
  paid: "Pago",
  pending: "Pendente",
  failed: "Falhou",
  refunded: "Reembolsado",
  initiated: "Iniciado",
};

const MONTHS_PT = [
  "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
  "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro",
];

// "2026-07" → "Julho-2026"
export function formatMonthYear(ym) {
  if (!ym || String(ym).length < 7) return ym || "";
  const [y, m] = String(ym).split("-");
  const name = MONTHS_PT[Number(m) - 1];
  return name ? `${name}-${y}` : ym;
}

export const ROLE_LABEL = {
  super_admin: "Super Admin",
  company_admin: "Admin da Empresa",
  manager: "Gestor",
  supervisor: "Supervisor",
  operator: "Operador",
  auditor: "Auditor",
  timeclock_kiosk: "Batida de Ponto",
};
